import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

/**
 * VERIFIED EMAIL CHANGE — the two calls behind it.
 *
 * Neither dispatches into the store. The address on the profile does not move
 * when the request is made, so there is nothing to update yet; and the confirm
 * page runs without a session, so there is no profile slice to update at all.
 * `fetchOwnProfile` is what re-reads the address once it has actually changed.
 *
 * Both REJECT with the server's body. Unlike password recovery, the refusals
 * here are meant to be read: the caller is authenticated and asking about
 * their own account, so «already in use» and «same address» are answers they
 * are entitled to and cannot act without.
 */

/** Ask to move to a new address. Authenticated; the account comes from the token. */
export const requestEmailChange = email =>
    () => axios(apiRequestOptions(apiPath.USER.EMAIL_CHANGE_REQUEST, { email }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            throw (error && error.response && error.response.data) || error;
        });

/**
 * Prove the CURRENT address (24 Oct 2026): the same one-time link, mailed to
 * the address the account has. Authenticated.
 */
export const requestEmailVerification = () =>
    () => axios(apiRequestOptions(apiPath.USER.EMAIL_VERIFICATION_REQUEST))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            throw (error && error.response && error.response.data) || error;
        });

/** Spend the link and adopt the address. Anonymous — opened from a mail client. */
export const confirmEmailChange = (selector, token) =>
    () => axios(apiRequestOptions(
        apiPath.USER.EMAIL_CHANGE_CONFIRM,
        { selector, token },
        { withoutAuth: true },
    ))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            throw (error && error.response && error.response.data) || error;
        });
